import { search_children } from "dependencies/search/index.js"
// import icon from "../../../../assets/images/leftMenu/basePortal/icon_search.png"
let icon = "icon-portal-menu_search"
export default {
  name: "搜索",
  id: "",
  thumbnail: icon,
  type: "cxSystemSearch",
  componentType:"emptyLayoutComponent",
  // typeId: "EDD9591561B57C17",
  typeId: "",
  children: []
  // children: search_children
}
